import { Header } from '../components/Header.js';
import { Hero } from '../components/Hero.js';
import { Modes } from '../components/Modes.js';
import { Duplicates } from '../components/Duplicates.js';
import { Systems } from '../components/Systems.js';
import { ConnectorDirectory } from '../components/ConnectorDirectory.js';
import { Agents } from '../components/Agents.js';
import { Safety } from '../components/Safety.js';
import { Pricing } from '../components/Pricing.js';
import { FinalCta } from '../components/FinalCta.js';
import { Footer } from '../components/Footer.js';
import type { useCurrency } from '../hooks/useCurrency.js';

export interface LandingProps {
  currency: ReturnType<typeof useCurrency>;
  onGoDocs: () => void;
  onGoConnectorsDocs: () => void;
  onGoHome: () => void;
  onGoPricing: () => void;
  onGoLegal: () => void;
  onOpenVideo: () => void;
  onOpenAudit: () => void;
  onOpenSandbox: () => void;
  onOpenBooking: () => void;
  onToggleHelp: () => void;
}

/**
 * Section order matters here. The hero promises "get your data AI-ready, then
 * keep it that way", so Modes comes straight after it: the reader's next
 * question is what each of those means and which one they are buying. Duplicates
 * then supplies the depth proof for the hardest step — it was the hero until
 * 2026-07-30, and leading with it sold a dedupe tool rather than the platform.
 */
export function Landing({
  currency,
  onGoDocs,
  onGoConnectorsDocs,
  onGoHome,
  onGoPricing,
  onGoLegal,
  onOpenVideo,
  onOpenAudit,
  onOpenSandbox,
  onOpenBooking,
  onToggleHelp,
}: LandingProps) {
  return (
    <section data-screen-label="Landing">
      <Header
        view="home"
        ccyCode={currency.code}
        regionLabel={currency.regionLabel}
        onCycleCurrency={currency.cycle}
        onGoHome={onGoHome}
        onGoDocs={onGoDocs}
        onOpenAudit={onOpenAudit}
        onOpenBooking={onOpenBooking}
        onToggleHelp={onToggleHelp}
      />
      <Hero onOpenAudit={onOpenAudit} onWatchVideo={onOpenVideo} />
      <Modes onOpenSandbox={onOpenSandbox} onOpenAudit={onOpenAudit} onGoPricing={onGoPricing} />
      <Duplicates moneyBig={currency.moneyBig} ccyCode={currency.code} />
      <Systems onGoDocs={onGoConnectorsDocs} />
      <ConnectorDirectory onGoConnectorsDocs={onGoConnectorsDocs} />
      <Agents />
      <Safety />
      <Pricing
        ccyCode={currency.code}
        ccySymbol={currency.symbol}
        ccyName={currency.name}
        taxLabel={currency.taxLabel}
        ccyNote={currency.note}
        onCycleCurrency={currency.cycle}
        onStartAudit={onOpenAudit}
        onOpenBooking={onOpenBooking}
        onGoPricing={onGoPricing}
      />
      <FinalCta ccyCode={currency.code} onOpenAudit={onOpenAudit} onWatchVideo={onOpenVideo} />
      <Footer onGoDocs={onGoDocs} onGoPricing={onGoPricing} onGoLegal={onGoLegal} />
    </section>
  );
}
